import RequestAccessForm from '@/lib/requestAccess/models/RequestAccessForm';

const siteRequestAccessForm = 'https://app.smartsheet.com/b/form/1e0d1011a67840b38a91a0e8be6e1540';
class StarfishRegistrationRequestForm extends RequestAccessForm {
  constructor() {
    super(siteRequestAccessForm);
  }
}

export default StarfishRegistrationRequestForm;
